import { Component, Input } from '@angular/core';
import { FileUploadComponent } from '@app/shared/components/file-upload/file-upload.component';

@Component({
  selector: 'smp-dropzone',
  templateUrl: './dropzone.component.html',
  styleUrls: ['./dropzone.component.scss']
})
export class DropzoneComponent extends FileUploadComponent {

  @Input()
  public addButtonLabel?: string;

  public dragging: boolean;

  @Input()
  public hasContent: boolean;

  constructor() {
    super();
  }

  public onDragging(event: boolean) {
    this.dragging = event;
  }
}
